import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Button } from '@calendly/ui/components/button';
import { CloseIcon } from '@calendly/ui/components/icons';
import { Loader } from '@calendly/ui/components/loader';
import { Modal } from '@calendly/ui/components/modal';
import { Sheet } from '@calendly/ui/components/sheet';
import { HeadingText, BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDestroyTrackedMeetingMutation, useFetchTrackedMeetingWithSummaryQuery } from 'hooks/tracked_meetings/api/index';
const styledSheetIsPhoneCss = "s1u4pvrs";
const styledSheetCss = "s1hmxeum";
const StyledSheet = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <Sheet ref={ref} {...props} className={classNames(styledSheetCss, {
    [styledSheetIsPhoneCss]: isPhone
  }, props.className)} />;
});
const headerWrapperCss = "hxhyccn";
const HeaderWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerWrapperCss, props.className)} />;
});
const footerWrapperCss = "f1a8yw7y";
const FooterWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(footerWrapperCss, props.className)} />;
});
export const DeleteRecapsModal = ({
  isOpen,
  meetingUuids,
  onClose,
  onSuccess
}) => {
  // Preserve optimistic update behavior for single UUID callers
  const singleUuid = meetingUuids.length === 1 ? meetingUuids[0] : null;
  const {
    data,
    isLoading
  } = useFetchTrackedMeetingWithSummaryQuery({
    meetingUuid: singleUuid
  }, {
    skip: !isOpen || !singleUuid
  });
  const [destroy] = useDestroyTrackedMeetingMutation();
  const onDelete = async () => {
    try {
      await Promise.all(meetingUuids.map(meetingUuid => {
        const foreignEventId = singleUuid === meetingUuid ? data?.foreignEventId : undefined;
        return destroy({
          meetingUuid,
          foreignEventId
        }).unwrap();
      }));
      onSuccess?.();
      onClose();
    } catch (error) {
      console.error('Error deleting recaps:', error);
      onClose();
    }
  };
  if (isLoading && singleUuid) {
    return <Loader />;
  }
  return <Modal isOpen={isOpen} onClose={onClose}>
      <StyledSheet>
        <HeaderWrapper>
          <HeadingText size="medium">
            {I18n.t('publisher.meeting_intelligence.details.delete_recap_modal.heading')}
          </HeadingText>
          <BareButton onClick={onClose} aria-label={I18n.t('publisher.action.close')}>
            <CloseIcon size="large" />
          </BareButton>
        </HeaderWrapper>
        <BodyText>
          {singleUuid ? HtmlParser(I18n.t('publisher.meeting_intelligence.details.delete_recap_modal.text')) : HtmlParser(I18n.t('publisher.meeting_intelligence.details.delete_recap_modal.text_plural'))}
        </BodyText>
        <BodyText>
          {singleUuid ? HtmlParser(I18n.t('publisher.meeting_intelligence.details.delete_recap_modal.note')) : HtmlParser(I18n.t('publisher.meeting_intelligence.details.delete_recap_modal.note_plural'))}
        </BodyText>
        <FooterWrapper>
          <Button decoration="secondary-outline" wide onClick={onClose}>
            {I18n.t('publisher.action.nevermind')}
          </Button>
          <Button decoration="danger" wide onClick={event => {
          event.preventDefault();
          event.stopPropagation();
          onDelete();
        }}>
            {singleUuid ? I18n.t('publisher.meeting_intelligence.details.delete_recap_modal.delete_button_single') : I18n.t('publisher.meeting_intelligence.details.delete_recap_modal.delete_button_multiple', {
            count: meetingUuids.length
          })}
          </Button>
        </FooterWrapper>
      </StyledSheet>
    </Modal>;
};

require("./delete_recap_modal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./delete_recap_modal.js");